import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class FinishedTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `finishedTasksList`,
      queryParamsStatic: {
        status: 4
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(FinishedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/FinishedTasksList/FinishedTasksList.js